import React from 'react';
import { DelegatesList } from './delegatesList';

const Delegates = () => {
    return (
        <>
            <DelegatesList />
        </>
    );
};

export default React.memo(Delegates);
